import React from 'react';
import { cn } from '../../../lib/utils';
import { RetryButton } from '../retry/RetryButton';

interface ErrorDisplayProps {
  // Specific error message
  error?: string | null;
  // To handle the retry action
  onRetry?: () => void;
  // Main error heading, with a sensible default
  title?: string;
  // additional styling of the container
  className?: string;
  // conditionally display the retry button
  showRetryButton?: boolean;
  // Effectively passes the loading state to the retry button
  isRetrying?: boolean;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onRetry,
  title = "We're sorry, something went wrong on our end. Please refresh the page or try again shortly.",
  className,
  showRetryButton = true,
  isRetrying = false
}) => {
  return (
    <div className={cn("p-6 text-center border rounded-lg border-red-500 text-gray-800", className)}>
      <h3 className="font-semibold text-lg mb-2">{title}</h3>
      <p className="text-sm mb-4">{error || 'An unknown error occurred.'}</p>
      {showRetryButton && onRetry && (
        <RetryButton 
          onClick={onRetry}
          isLoading={isRetrying}
          disabled={isRetrying}
        />
      )}
    </div>
  );
};